import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CYAN, MUTED } from './tokens';
import { useChromeHeader } from '../chrome/ChromeContext';

/**
 * The collapsing title bar mobile pages get instead of the TopBar: ← · truncated title ·
 * right slot (price, pill). Sticky at the very top; the tab strip measures it. Padding is
 * the `.surface-title-bar` class so the status-bar inset (env()) is added on top of the 10px
 * in the native shells — an inline `padding` would override the inset. Carries
 * `data-mob-header` so MobileTabStrip can find it. `dark` = host surfaces (black bar with a
 * cyan eyebrow); `eyebrow` adds the small caps line above the title.
 */
export default function MobileTitleBar(props) {
  const hosted = useChromeHeader('title', props);
  return hosted ? null : <MobileTitleBarContent {...props} />;
}

export function MobileTitleBarContent({ title, eyebrow, right, onBack, dark = false, testId = 'mobile-title-bar' }) {
  const navigate = useNavigate();
  const back = onBack || (() => navigate(-1));
  return (
    <div
      data-mob-header="1"
      className={`surface-title-bar sticky top-0 z-20 flex items-center gap-[10px] ${dark ? 'bg-black text-white' : 'border-b-2 border-black bg-white text-black'}`}
      data-testid={testId}
    >
      <button type="button" onClick={back} aria-label="Back" className="flex-none font-mono font-bold" style={{ fontSize: 18, lineHeight: 1 }}>←</button>
      <div className="min-w-0 flex-1" style={{ lineHeight: 1.25 }}>
        {eyebrow && <div className="font-mono font-bold uppercase" style={{ fontSize: 9, letterSpacing: '0.2em', color: dark ? CYAN : MUTED }}>{eyebrow}</div>}
        <div className="truncate font-mono font-bold uppercase" style={{ fontSize: 12, letterSpacing: '0.05em' }}>{title}</div>
      </div>
      {right && <div className="flex-none font-mono font-bold" style={{ fontSize: 12 }}>{right}</div>}
    </div>
  );
}
